import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Accordion } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FaFilter } from 'react-icons/fa';
import './filter.scss';
import { useNavigate } from 'react-router-dom';

export default function Filters({ filterData, handleFilter, emptyFilter, statusData, redirectTo }) {
    const [role, setRole] = useState([]);
    const [status, setStatus] = useState([]);
    const navigate = useNavigate();

    useEffect(() => { setRole([]); setStatus([]); }, [emptyFilter]);

    const handleRoleChange = ({ role_id, role_name, e }) => {
        const { checked } = e.target;
        if (checked) setRole([...role, { role_id, role_name }]);
        else setRole(role.filter(r => r.role_id !== role_id));
    };

    const handleStatusChange = (e) => {
        const { value, checked } = e.target;
        if (checked) setStatus([...status, value]);
        else setStatus(status.filter(s => s !== value));
    };

    const handleSubmit = () => { handleFilter({ role, status }); navigate(redirectTo); };
    const handleClear = () => { setRole([]); setStatus([]); handleFilter({ role: [], status: [] }); };

    const popover = (
        <div className="my-1 shadow-lg bg-light rounded p-2 border" style={{ width: '20em' }}>
            <Accordion className="my-2">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Role</Accordion.Header>
                    <Accordion.Body style={{ marginTop: '10px', marginBottom: '10px' }}>
                        {filterData?.map(({ role_id, role_name, isHeading, indent }) => (
                            <div key={role_id} className={isHeading ? 'fw-bold mt-2 mb-1' : ''} style={{ paddingLeft: indent ? '20px' : '0px' }}>
                                {!isHeading && (
                                    <div className="d-flex mb-1">
                                        <input
                                            type="checkbox"
                                            id={role_id}
                                            value={role_id}
                                            checked={role.find(r => r.role_id === role_id)}
                                            onChange={(e) => handleRoleChange({ role_id, role_name, e })}
                                        />
                                        <label className="px-2" htmlFor={role_id}>{role_name}</label>
                                    </div>
                                )}
                                {isHeading && <div>{role_name}</div>}
                            </div>
                        ))}
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Status</Accordion.Header>
                    <Accordion.Body style={{ marginTop: '10px', marginBottom: '10px' }}>
                        {statusData.map((s, idx) => (
                            <div key={idx} className="d-flex">
                                <input
                                    type="checkbox"
                                    checked={status.includes(s)}
                                    onChange={handleStatusChange}
                                    value={s}
                                    name={s}
                                />
                                <label className="px-2">{s}</label>
                            </div>
                        ))}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Row>
                <Col md={7}>
                    <Button className="custom-button-reset bg-secondary border border-secondary" onClick={handleClear}>Reset</Button>
                </Col>
                <Col md={4}>
                    <Button className="custom-button-do" variant="success" onClick={handleSubmit}>Filter</Button>
                </Col>
            </Row>
        </div>
    );

    return (
        <div className="d-flex flex-row-reverse">
            <OverlayTrigger rootClose trigger="click" placement="bottom-end" overlay={popover}>
                <Button variant="dark" className="mx-3" style={{ background: '#3B6FD0', border: 'solid 1px #3B6FD0' }}>
                    <FaFilter className="mt-1" />
                </Button>
            </OverlayTrigger>
            <div className="overflow-auto" style={{ width: '75%' }}>
                {role?.length > 0 && (
                    <div className="d-flex flex-row-reverse overflow-auto m-1">
                        {role.map((r) => (
                            <div key={r.role_id} className="text-success mx-1 border border-success rounded-1 px-1 label-bg" style={{ fontSize: '0.65em' }}>
                                {r.role_name}
                            </div>
                        ))}
                        <div className="fw-bold" style={{ fontSize: '0.8em' }}>Role:</div>
                    </div>
                )}
                {status?.length > 0 && (
                    <div className="d-flex flex-row-reverse overflow-auto">
                        {status.map((s, idx) => (
                            <div key={idx} className="text-success mx-1 border border-success rounded-1 px-1 label-bg" style={{ fontSize: '0.65em' }}>
                                {s}
                            </div>
                        ))}
                        <div className="fw-bold" style={{ fontSize: '0.8em' }}>Status:</div>
                    </div>
                )}
            </div>
        </div>
    );
}
